import React, { useState, useEffect, useCallback, useContext } from 'react'
import { AppContext, useWithAuth } from '../../containers/App'
import styled from 'styled-components'
import { map, xor, includes } from 'lodash/fp'
import { Helmet } from 'react-helmet'

import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
import Table from '../../components/Table'
import Search from '../../components/Search/index'
import colors from '../../styles/colors'
// @ts-ignore @todo add apprioprate declaration file
import withLoading from '../../utils/withLoading'
import { useNotifications } from '../Notifications'
import { normalizeSortState } from '../../components/Table/convertSortState'
import Checkbox from '../../components/Checkbox'
// @ts-ignore @todo add apprioprate declaration file
import sendIcon from '../../images/sendIconRed.svg'
// @ts-ignore @todo add apprioprate declaration file
import downloadIcon from '../../images/downloadIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import { SendMailModal } from './SendMailModal'
import { subAreas as subAreasConstant } from '../../utils/constants'
import { Hidden } from '../../styles/Shared'
import Button from '../../components/Button'
// @ts-ignore @todo add apprioprate declaration file
import filtersIcon from '../../images/filtersIcon.svg'
// import FilterForm from './FilterForm'
import FilterForm from './FilterForm'
import {
  Materials,
  ChangedMaterials,
  OpenModalProps,
  ModalStateProps,
} from './utils'

const endpoint = '/report/rest/material/search'

const PostDiagnosticList = () => {
  const [materials, setMaterials] = useState<Materials[]>()
  const [reFetch, setReFetch] = useState(true)
  const [changedMaterials, setChangedMaterials] = useState<
    ChangedMaterials[] | Materials[]
  >()
  const [ready, setReady] = useState<boolean>(false)
  const [singularSend, setSingularSend] = useState<boolean>(false)
  const [singularDiagnostic, setSingularDiagnostic] = useState<string[]>(null)
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const LoadingTable = withLoading(Table)

  const [state, setState] = useState({
    sorts: {},
    meta: {
      limit: 10,
      page: 0,
      total: 0,
    },
    filters: {
      speSubgroups: null,
      speGroups: null,
      areas: null,
      kinds: null,
    },
    filenames: [],
  })
  const [openModal, setOpenModal] = useState<OpenModalProps>({ open: false })
  const [modalState, setModalState] = useState<ModalStateProps>({
    recipients: [],
    materialFilenames: [],
  })
  const { toggleFilters } = useContext(AppContext)

  const onFiltersChange = (filters) => {
    setState({
      ...state,
      filters: {
        ...filters,
        minAge:
          filters?.minAge === 0 || filters?.minAge === ''
            ? null
            : filters?.minAge * 12,
        maxAge:
          filters?.maxAge === '' || filters?.maxAge === 0
            ? null
            : filters?.maxAge * 12,
        areas:
          filters.areas && filters.areas.length !== 0 ? filters.areas : null,
        kinds:
          filters.kinds && filters.kinds.length !== 0 ? filters.kinds : null,
        speGroups:
          filters.speGroups && filters.speGroups.length !== 0
            ? filters.speGroups
            : null,
        speSubgroups:
          filters.speSubgroups && filters.speSubgroups.length !== 0
            ? filters.speSubgroups
            : null,
      },
    })
    setReFetch(true)
  }

  const onPageChange = (index) => {
    setState({ ...state, meta: { ...state.meta, page: index } })
    setReFetch(true)
  }

  const fetchMaterials = async () => {
    setReady(false)
    const result = await withAuth(`${endpoint}`, {
      method: 'POST',
      payload: {
        filters: {
          ...state.filters,
        },

        meta: {
          ...state.meta,
          sorts: normalizeSortState(state.sorts),
        },
      },
    })
    setReady(true)
    return result
  }

  const fetchData = async () => {
    try {
      const result = await fetchMaterials()
      const filenames = map('filename', result.models)
      setMaterials(result.models)
      setState({ ...state, meta: { ...result.meta }, filenames })
    } catch {
      notify('Nie udało się pobrać materialów postdiagnostycznych', 'error')
    }
  }

  useEffect(() => {
    setReFetch(false)
    fetchData()
  }, [reFetch === true])

  const onSearchChange = (search) => {
    setState((prevState) => ({
      ...prevState,
      filters: { ...prevState.filters, search },
      meta: { ...prevState.meta, page: 0 },
    }))
    setReFetch(true)
  }

  const setItemSelection = (items) =>
    setModalState({
      recipients: [],
      materialFilenames: [...items],
    })

  const handleMailSending = useCallback(
    (vals, isSingular: boolean) => {
      const sendMail = async () => {
        const result = await withAuth(`/report/rest/material/send`, {
          method: 'POST',
          payload: {
            recipients: vals.recipients.split(','),
            materialFilenames: isSingular
              ? singularDiagnostic
              : modalState.materialFilenames,
          },
        })
        result
          ? notify('Zarejestrowano zlecenie wysyłki', 'success')
          : notify(
              'Nie udało zarejestrować zlecenia wysyłki, spróbuj ponownie',
              'error'
            )
        setModalState({
          recipients: [],
          materialFilenames: [],
        })
        setSingularDiagnostic(null)
        setOpenModal({ open: false })
      }
      sendMail()
    },
    [modalState, openModal, withAuth, notify]
  )

  useEffect(() => {
    if (materials && !!materials.length) {
      const materialNamesArray = materials.map((el) => el.displayedName)

      const lettersArray = [
        { letter: materialNamesArray[0].charAt(0), index: 0 },
      ]
      let firstLetterInTheLoop = lettersArray[0].letter.toUpperCase()
      for (let i = 0; i < materialNamesArray.length; i++) {
        if (i > 0) {
          if (
            materialNamesArray[i].charAt(0).toLocaleUpperCase() ===
            firstLetterInTheLoop
          ) {
            lettersArray.push({ letter: '', index: i })
            firstLetterInTheLoop = materialNamesArray[i].charAt(0)
          } else {
            lettersArray.push({
              letter: materialNamesArray[i].charAt(0),
              index: i,
            })
            firstLetterInTheLoop = materialNamesArray[i].charAt(0)
          }
        }
      }

      setChangedMaterials(
        materials.map((el, index) => ({
          ...el,
          alphabet: lettersArray[index].letter,
          maxAge: `${Math.floor(materials[index].maxAge / 12)};${
            materials[index].maxAge % 12
          }`,
          minAge:
            materials[index].minAge === 0
              ? '0;0'
              : `${Math.floor(materials[index].minAge / 12)};${
                  materials[index].minAge % 12
                }`,
        }))
      )
    } else setChangedMaterials(materials)
  }, [materials])

  const isAnyRowChecked: boolean = modalState.materialFilenames.length != 0

  return (
    <Layout
      filters={
        <FilterForm
          initialValues={{
            ...state.filters,
            maxAge: state.filters?.maxAge / 12,
            minAge: state.filters?.minAge / 12,
          }}
          onClose={toggleFilters}
          onSubmit={onFiltersChange}
        />
      }
    >
      <Helmet htmlAttributes={{ lang: 'pl-PL' }}>
        <title>Materiały wspierające diagnozę i postdiagnostyczne</title>
      </Helmet>
      <Heading
        title={
          <span>
            <SendPositioner isHidden={isAnyRowChecked === false}>
              <span aria-live="polite">
                Wybrano {modalState.materialFilenames.length}
              </span>
              <Button
                link={null}
                icon={sendIcon}
                color="white"
                label="Wyślij"
                marginLeft
                width="200px"
                onClick={() => {
                  setOpenModal({ open: true })
                  setSingularSend(false)
                }}
                altTag=""
                srText=""
              />
            </SendPositioner>
            <HeadingTitle isHidden={isAnyRowChecked === true}>
              Materiały wspierające diagnozę i postdiagnostyczne
            </HeadingTitle>
          </span>
        }
      >
        <div style={{ width: '100%' }}>
          <label>
            <Search
              width={450}
              ariaLabel={
                state.filters.search
                  ? `Szukaj liczba znalezionych wyników: ${
                      materials != null ? materials.length : 0
                    }`
                  : 'Szukaj'
              }
              placeholder="Szukaj"
              input={{ onChange: onSearchChange, value: '' }}
            />
          </label>
        </div>
        <Button
          link=""
          icon={filtersIcon}
          color="white"
          label="Filtruj"
          onClick={toggleFilters}
          marginLeft
          altTag=""
          srText=""
          imgAriaHidden={true}
        />
      </Heading>
      <PanelWrapper>
        <LoadingTable
          borderTable
          page={state.meta.page}
          total={state.meta?.total}
          defaultPageSize={state.meta.limit}
          onPageChange={(index) => onPageChange(index)}
          order={state.sorts}
          ready={ready}
          getLoadingProps={() => ({
            'aria-hidden': true,
            role: 'none',
          })}
          data={changedMaterials}
          getTheadTrProps={() => ({
            style: { display: 'flex', alignItems: 'center' },
          })}
          getTheadThProps={(state, _undefined, column) => ({
            style: { marginRight: column.id === 'id' ? '-40px' : 'auto' },
          })}
          columns={[
            {
              id: 'id',
              sortable: false,
              resizable: false,
              Header: (
                <Checkbox
                  hiddenLabel
                  label="Zaznacz wszystkie materiały na stronie"
                  aria-label="Zaznacz wszystkie materiały na stronie"
                  input={{
                    value:
                      xor(state.filenames, modalState.materialFilenames)
                        .length === 0,
                    onChange: () => {
                      setItemSelection(
                        xor(state.filenames, modalState.materialFilenames)
                          .length === 0
                          ? []
                          : state.filenames
                      )
                    },
                  }}
                />
              ),
              Cell: ({ original }) => (
                <StyledCheckbox
                  hiddenLabel
                  label="Zaznacz materiał"
                  input={{
                    value: includes(
                      original.filename,
                      modalState.materialFilenames
                    ),
                    onChange: () =>
                      setItemSelection(
                        xor([original.filename], modalState.materialFilenames)
                      ),
                  }}
                />
              ),
              getProps: () => ({
                onClick: (e) => e.stopPropagation(),
                style: { marginRight: '-50px' },
              }),
            },
            {
              Header: 'Nazwa',
              sortable: false,
              id: 'displayedName',
              accessor: ({ displayedName }) => (
                <TooltipWrap>
                  <span>{displayedName}</span>
                  <Tooltip>
                    <div className="arrow-box">{displayedName}</div>
                  </Tooltip>
                </TooltipWrap>
              ),
            },
            {
              Header: 'Rozmiar',
              sortable: false,
              id: 'size',
              accessor: ({ size }) => size,
              getProps: () => ({
                role: undefined,
              }),
            },

            {
              Header: 'Grupa / podgrupa SPE',
              id: 'speGroups',
              sortable: false,
              accessor: ({ speGroups }) =>
                speGroups.map((speGroups) => `${speGroups}; `),
              getProps: () => ({
                role: undefined,
              }),
            },

            {
              Header: 'Przedział wieku',
              id: 'age',
              sortable: false,
              accessor: ({ minAge, maxAge }) => `${minAge} do ${maxAge}`,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: 'Obszary / podobszary',
              id: 'subAreas',
              sortable: false,

              accessor: ({ subAreas }) =>
                subAreas.map((subArea) =>
                  subAreasConstant[subArea]
                    ? `${subAreasConstant[subArea]}; `
                    : `${subArea}; `
                ),
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: 'Rodzaj materiału postdiagnostycznego',
              id: 'kind',
              sortable: false,
              accessor: ({ kind }) => kind,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: <Hidden>Akcja</Hidden>,
              id: 'akcji1',
              sortable: false,
              Cell: ({ original }) => (
                <IconButton
                  type="button"
                  onClick={() => {
                    setOpenModal({ open: true })
                    setSingularSend(true)
                    setSingularDiagnostic(
                      xor([original.filename], singularDiagnostic)
                    )
                  }}
                >
                  <BtnWrapper>
                    Wyślij
                    <Img alt="" src={sendIcon} aria-hidden="true" />
                  </BtnWrapper>
                </IconButton>
              ),
            },
            {
              Header: <Hidden>Akcja</Hidden>,
              id: 'akcji2',
              sortable: false,
              Cell: ({ original }) => (
                <StyledHyperlink
                  download
                  href={`../../doc/${original.filename.replaceAll(' ', '%20')}`}
                >
                  <BtnWrapper>
                    Pobierz
                    <Img alt="" src={downloadIcon} aria-hidden="true" />
                  </BtnWrapper>
                </StyledHyperlink>
              ),
            },
          ]}
        />
      </PanelWrapper>
      {openModal.open && (
        <SendMailModal
          isOpen={openModal.open}
          onClose={() => {
            setOpenModal({ open: false })
            setModalState({
              recipients: null,
              materialFilenames: [],
            })
            setSingularDiagnostic(null)
          }}
          onSubmit={(vals) => {
            handleMailSending(vals, singularSend)
          }}
        />
      )}
    </Layout>
  )
}

export default PostDiagnosticList

const PanelWrapper = styled.div`
  margin-top: 30px;
  padding: 2em;
`
const Img = styled.img`
  margin-left: 10px;
`

const IconButton = styled.button`
  display: flex;
  margin-right: 25px;
  color: ${colors.monza};
  background: transparent;
  border: none;
  align-items: center;
  cursor: ${(props) => !props.disabled && `pointer;`};
  height: auto;
  border-radius: 5px;
  > * {
    padding: 0 0 0 3px;
  }
  ${Img} {
    opacity: ${(props) => props.disabled && `50%`};
  }
`
const StyledHyperlink = styled.a`
  display: flex;
  margin-right: 25px;
  color: ${colors.monza};
  border: none;
  text-decoration: none;
  align-items: center;
  cursor: ${(props) => !props.disabled && `pointer;`};
  height: auto;
  border-radius: 5px;
  > * {
    padding: 0 0 0 3px;
  }
  ${Img} {
    opacity: ${(props) => props.disabled && `50%`};
  }
  a {
  }
`
const StyledCheckbox = styled(Checkbox)`
  margin-top: 15px;
`

const SendPositioner = styled.span`
  display: flex;
  align-items: center;
  ${({ isHidden }) => isHidden && 'display: none'};
  h2 {
    margin-right: 10px;
    margin-top: 20px;
    color: ${colors.monza};
    font-family: Raleway;
    font-weight: 200;
  }
`

const HeadingTitle = styled.span`
  display: block;
  ${({ isHidden }) => isHidden && 'display: none'};
`

const BtnWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Raleway;
  font-weight: 200;
  font-size: 14px;
`
const Tooltip = styled.div`
  display: none;
`
const TooltipWrap = styled.div`
  &:hover ${Tooltip} {
    z-index: 100;
    margin-top: -5rem;
    position: absolute;
    display: block;
    color: white;
    background: #454545;
    border-radius: 4px;
    padding: 4px 12px;
    white-space: normal;
    min-width: 350px;
    line-height: 24px;
    min-height: 30px;

    .arrow-box:after {
      position: absolute;
      border: 8px solid transparent;
      border-top-color: #454545;
      content: ' ';
      height: 0;
      width: 0;
      top: 100%;
      left: 20px;
    }
  }
`
